export default __webpack_public_path__ + "static/media/NotificationCross.a14b4036.svg";